import { useEffect, useState } from 'react';

import { authStorage } from 'utils/storage';

export function useAuthStatus() {
  const [isAuthenticated, setIsAuthenticated] = useState(authStorage.hasToken());

  useEffect(() => {
    const updateAuth = () => setIsAuthenticated(authStorage.hasToken());

    window.addEventListener('storage', updateAuth);
    window.addEventListener('auth-change', updateAuth);

    return () => {
      window.removeEventListener('storage', updateAuth);
      window.removeEventListener('auth-change', updateAuth);
    };
  }, []);

  return isAuthenticated;
}
